// main.js
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/css/reset.css'
import 'vant/lib/index.css';
// import VConsole from 'vconsole';

// eslint-disable-next-line no-unused-vars
// const vConsole = new VConsole();
// 或者使用配置参数来初始化，详情见文档

// 接下来即可照常使用 `console` 等方法
import api from './request/index.js' // 导入api接口
Vue.prototype.$api = api; // 将api挂载到vue的原型上
Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: (h) => h(App)
}).$mount('#app')
